import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { downloadConsultantRatingsExcel_API, getConsultantRatings_API} from '../../../../Config/Api';
import { createNotification } from '../../../../Config/NotificationToast';
import { logOut } from "../../../../utils/Helper";
import { instance } from "../../../auth/axiosInstance";
import * as types from '../../../constants'

export default function* consultantRatings() {
    yield takeEvery(types.GET_CONSULTANT_RATINGS_DATA, getConsultantRatingsDataSaga);
    yield takeLatest(types.DOWNLOAD_CONSULTANT_RATING_EXCEL, downloadConsultantRatingExcel);
}

const getConsultantRatingsData = async (data) => {
    try {
        const response = await instance.get(`${getConsultantRatings_API}?start_date=${data.filter_from}&end_date=${data.filter_to}`);
        return response;
    } catch (errors) {
        console.log("errors", errors);

        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* getConsultantRatingsDataSaga(action) {
    try {
        const response = yield call(getConsultantRatingsData, action.data);
        const ConsultantRatingsDataRes = response
        if (ConsultantRatingsDataRes.statusCode === 200) {
            yield put({ type: types.GET_CONSULTANT_RATINGS_DATA_SUCCESS, consultantRatingsRes: ConsultantRatingsDataRes.data });
            if(ConsultantRatingsDataRes.data.length===0){
                createNotification('error', 'No data found')
                yield put({ type: types.GET_CONSULTANT_RATINGS_DATA_FAILURE, message: 'No data found' });
            }
        } else {
            if (ConsultantRatingsDataRes.statusCode === 401) {
                logOut('error', ConsultantRatingsDataRes.message)
            } else {
                console.log(ConsultantRatingsDataRes.message);
                createNotification('error', ConsultantRatingsDataRes.message);
                yield put({ type: types.GET_CONSULTANT_RATINGS_DATA_FAILURE, message: ConsultantRatingsDataRes.message });
            }
        }
    } catch (e) {
        yield put({ type: types.GET_CONSULTANT_RATINGS_DATA_FAILURE, message: "" });
    }
}


const downloadConsultantRatingExcelApi = async(data)=> {
    try {
        const response = await instance.get(`${downloadConsultantRatingsExcel_API}?start_date=${data.filter_from}&end_date=${data.filter_to}`, {
            responseType: 'arraybuffer',
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response?.data.statusCode === 400) {
            createNotification('error', errors.response?.data.message);
            return
        } if (errors.response?.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
  }

  function* downloadConsultantRatingExcel(action) {
    try {
        
        let data=action.data
        const response = yield call(downloadConsultantRatingExcelApi, data);
        if (response instanceof ArrayBuffer) {
            action.data?.onSuccessCallback(response)
            yield put({ type: types.DOWNLOAD_CONSULTANT_RATING_EXCEL_SUCCESS });
        }else{
            createNotification('Unable to download sheet.')
            yield put({ type: types.DOWNLOAD_CONSULTANT_RATING_EXCEL_FALIURE});
        }
        
    } catch (e) {
        console.log(e);
        yield put({ type: types.DOWNLOAD_CONSULTANT_RATING_EXCEL_FALIURE, message: e.message });
    }
}